/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import TaskEnum from '../task-enum';

/**
 * Převaděč starých úloh na napájecí úlohy
 */
class TaskToPowerTaskConverter {
  /**
   * Převede starou úlohu na napájecí úlohu
   * @param {Store} store
   * @param {Task} task
   * @returns {PowerTask|undefined} Pokud nelze starou úlohu vytvořit,
   * vrací `undefined`.
   */
  convert(store, task) {
    // Úloha musí být napájecí.
    if (task.taskEnum !== TaskEnum.POWER) {
      return;
    }
    // Vytvoření napájecí úlohy v požadovaném datovém skladu.
    return store.inject('powerTask', { id: task.id });
  }
}

export default TaskToPowerTaskConverter;
